module.exports = __webpack_public_path__ + "static/media/former-address.e4986260.svg";